
import { FixQuery, Query } from './Query'
import { HttpVerb } from "../constants/HttpVerb"
import { fetchData as midFetch } from "./MiddleTier"

export const emptyQuery: Query = {}

const stringToArray = (s: string | string[]) => typeof s === 'string' ? s.split(';') : s

async function expandResult(o: any, expand: string[]) {
  for (const e of expand) {
    if (o[e] && (o[e] !== 'undefined')) { // Check if the property exists and is not undefined
      const type = e === 'Client' ? 'Contact' : e === 'Summary' ? 'CaseSummary' : ''
      if (type) {
        o[e] = (await fetchDataId(type, o[e])).data
      }
    }
  }
}

export async function fetchData(dataType: string, query: Query = emptyQuery) {
  const results = await midFetch('fetchData/' + dataType, HttpVerb.POST,  JSON.stringify(FixQuery(query)), 'text/plain; charset=UTF-8')

  const ex = stringToArray(query?.Expand ?? '')
  for (const r of results.data) {
    // r.objectId = r._id
    if (query?.Expand) {
      await expandResult(r, ex)
    }
  }
  results.results = results.data

  return Promise.resolve(results)
}

export async function fetchDataId(dataType: string, id: string, query: Query = emptyQuery) {
  // Return null if no Id.
  if (!id) {console.log("No ID provided");  return Promise.resolve(null)}
  try {
    const result = await midFetch('fetchDataId/' + dataType + '/' + id, HttpVerb.POST)
    // result.objectId = result._id
    if (query?.Expand) {
      await expandResult(result, stringToArray(query.Expand)) // Pass the array to expandResult function
    }
    return Promise.resolve(result)
  } catch (e) {
    console.error('Error fetching data by ID:', e)
    throw e
  }
}

// This works as an Upsert. If the objectId is supplied, it will update the record, otherwise it will create a new record
export async function saveData(dataType: string, o: any) {
  console.log("Saving data for type:", dataType, "with object:", o)
  const {objectId, createdAt, updatedAt, createdBy, ...rest} = o
  return await midFetch('saveData/' + dataType, HttpVerb.POST, JSON.stringify(rest))
}

export async function deleteDataId(dataType: string, id: string) {
  return await midFetch(`deleteDataId/${dataType}/${id}`, HttpVerb.POST)
}
